import React, {Component} from 'react';
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import { Table } from 'semantic-ui-react'
import {getChartColors, minutesToHuman} from '../../Helpers'
import {Pie} from 'react-chartjs-2';
import PropTypes from 'prop-types';
import ReportCommesseLavoratoriPerAnnoDetail from './ReportCommesseLavoratoriPerAnnoDetail'

class ReportCommesseLavoratoriPerAnno extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items:[],
            yearList:[],
            total: 0,
            durataTotale: 0,
            durataPesataTotale: 0,
            numAttivitaTotale: 0,
            _loading: false,
            error: null,
        };
        this.loadData = this.loadData.bind(this)
    }

    componentWillUnmount() {
    }

    componentDidMount() {
        this.loadData(this.props.commessa.idCommessa, this.props.dataStart, this.props.dataEnd);
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.commessa !== this.props.commessa || nextProps.dataStart !== this.props.dataStart || nextProps.dataEnd !== this.props.dataEnd)
        {
            this.loadData(nextProps.commessa.idCommessa, nextProps.dataStart, nextProps.dataEnd);
        }
    }

    loadData(idCommessa, dataStart, dataEnd) {

        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        let ds = new Date(dataStart);
        let de = new Date(dataEnd);
        let yearStart = ds.getFullYear();
        let yearEnd = de.getFullYear();
        let yearList = [];
        for (let i = yearStart; i<=yearEnd; i++){
            yearList.push(i);
        }
        this.setState({yearList: yearList, yearStart: yearStart, yearEnd:yearEnd, _loading: false});
    }

    render() {
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        return (<div>
            {this.state.yearList.map((year)=>
                (<div key={year}>
                    <h3 className="ui attached header">Anno {year}</h3>
                    <div className="ui attached segment" key={year}>
                    <ReportCommesseLavoratoriPerAnnoDetail commessa={this.props.commessa} anno={year} viewCharts={this.state.viewCharts} />
                    </div>
                    </div>
                 ))}
            {loader}
        </div>)
    }
}

ReportCommesseLavoratoriPerAnno.PropTypes = {
    commessa: PropTypes.object.isRequired,
    dataStart: PropTypes.string.isRequired,
    dataEnd: PropTypes.string.isRequired,
    viewCharts: PropTypes.bool.isRequired,
}


ReportCommesseLavoratoriPerAnno.defaultProps = {
    viewCharts: false,
};

export default ReportCommesseLavoratoriPerAnno;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportCommesseLavoratoriPerAnno.js
 **/